import { FC } from 'react';
import { Breadcrumb as IOBreadcrumb, BreadcrumbItem } from '@doda/io-react/pc';
import { BreadcrumbItemTop } from 'components/BreadcrumbItemTop';
import classnames from 'classnames';
import { BreadCrumb } from '@doda/common/src/interfaces/breadCrumb';
import styles from './index.module.scss';

/**
 * BreadCrumbListのProps
 * @param targetName ページに訪れたパラメータの項目名
 * @param breadcrumbData パンくずリストデータ
 * @param pageText ページ用パンくず文言
 */
export interface Props {
  targetName: string;
  breadcrumbData: BreadCrumb[];
  pageText: string;
}

export const BreadCrumbList: FC<Props> = ({
  targetName,
  breadcrumbData,
  pageText,
}) => {
  return (
    <IOBreadcrumb>
      <BreadcrumbItemTop />
      {breadcrumbData.map(({ breadCrumbText, breadCrumbLink, splitFlg }, i) => {
        return (
          <BreadcrumbItem
            className={classnames(styles.breadcrumb__item, {
              [styles.split]: splitFlg,
            })}
            href={i === breadcrumbData.length ? undefined : breadCrumbLink}
            key={i}
          >
            {breadCrumbText}
          </BreadcrumbItem>
        );
      })}
      <BreadcrumbItem>
        {targetName} {pageText}
      </BreadcrumbItem>
    </IOBreadcrumb>
  );
};
